import React, { Component } from "react";
import { NavLink } from "react-router-dom";

import { Menu, Icon } from "antd";

import "./Sidebar.css";
import { observer, inject } from "mobx-react";

@inject("translationsStore")
@observer
export default class Sidebar extends Component {
  render() {
    const t = this.props.translationsStore.current;
    return (
      <Menu className="Sidebar">
        <Menu.Item key="1">
          <NavLink activeClassName="active" to="/registrations">
            <Icon type="solution" />
            <span>{t["index"]["sidebar"]["lblPendingList"]}</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="2">
          <NavLink activeClassName="active" to="/clients">
            <Icon type="team" />
            <span>{t["index"]["sidebar"]["lblClientList"]}</span>
          </NavLink>
        </Menu.Item>
      </Menu>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/Sidebar/Sidebar.js